import { FC, PropsWithChildren } from "react";
export const Grid: FC<PropsWithChildren> = ({ children, ...rest }) => {
	return <div {...rest}>{children}</div>;
};
